module.exports = __webpack_public_path__ + "assets/images/profiles/2020-3.jpg?v=a916ef12";